import { useTranslation } from "@bounce/i18n"

export const useStoreTypeText = (type: string | undefined) => {
  const { t } = useTranslation("store")

  switch (type) {
    case "Adult Store":
      return t("cmp.useStorageTypeText.adultStore", "Adult Store")
    case "Barber Shop":
      return t("cmp.useStorageTypeText.barberShop", "Barber Shop")
    case "Beauty Salon":
      return t("cmp.useStorageTypeText.beautySalon", "Beauty Salon")
    case "Bike Rental":
      return t("cmp.useStorageTypeText.bikeRental", "Bike Rental")
    case "Cafe":
      return t("cmp.useStorageTypeText.cafe", "Cafe")
    case "Bar":
      return t("cmp.useStorageTypeText.bar", "Bar")
    case "Convenience Store":
      return t("cmp.useStorageTypeText.convenienceStore", "Convenience Store")
    case "Deli":
      return t("cmp.useStorageTypeText.deli", "Deli")
    case "Dessert Shop":
      return t("cmp.useStorageTypeText.dessertShop", "Dessert Shop")
    case "Dry Cleaner":
      return t("cmp.useStorageTypeText.dryCleaner", "Dry Cleaner")
    case "Electronics Store":
      return t("cmp.useStorageTypeText.electronicsStore", "Electronics Store")
    case "Fitness Center":
      return t("cmp.useStorageTypeText.gym", "Gym")
    case "Hair Salon":
      return t("cmp.useStorageTypeText.hairSalon", "Hair Salon")
    case "Hardware Store":
      return t("cmp.useStorageTypeText.hardwareStore", "Hardware Store")
    case "Luggage Storage":
      return t("cmp.useStorageTypeText.luggageStorage", "Luggage Storage")
    case "Hotel":
      return t("cmp.useStorageTypeText.hotel", "Hotel")
    case "Karaoke":
      return t("cmp.useStorageTypeText.karaokeShop", "Karaoke Shop")
    case "Office":
      return t("cmp.useStorageTypeText.office", "Office")
    case "Pharmacy":
      return t("cmp.useStorageTypeText.pharmacy", "Pharmacy")
    case "Print Shop":
      return t("cmp.useStorageTypeText.printingStore", "Printing Store")
    case "Restaurant":
      return t("cmp.useStorageTypeText.restaurant", "Restaurant")
    case "Retail Store":
      return t("cmp.useStorageTypeText.retailStore", "Retail Store")
    case "Shipping Store":
      return t("cmp.useStorageTypeText.shippingStore", "Shipping Store")
    case "Smoke Shop":
      return t("cmp.useStorageTypeText.smokeShop", "Smoke Shop")
    case "Souvenir Shop":
      return t("cmp.useStorageTypeText.souvenirShop", "Souvenir Shop")
    case "Stationary Store":
      return t("cmp.useStorageTypeText.stationaryStore", "Stationary Store")
    case "Tattoo Parlor":
      return t("cmp.useStorageTypeText.tattooParlor", "Tattoo Parlor")
    case "Travel Agency":
      return t("cmp.useStorageTypeText.travelAgency", "Travel Agency")
    case "Wellness Center":
      return t("cmp.useStorageTypeText.wellnessCenter", "Wellness Center")
    case "The UPS Store":
      return t("cmp.useStorageTypeText.upsStore", "The UPS Store")
    case "Locker":
      return t("cmp.useStorageTypeText.locker", "Locker")
    default:
      return t("cmp.useStorageTypeText.localShop", "Local shop")
  }
}
